import React from "react";
import "../styles/style.css";
import HeaderSerene from "../components/HeaderSerene";
import HeroMeadows from "../components/HeroMeadows";
import MeadowsLogo from "../assets/images/meadows-logo.png";
import "../styles/MeadowsSite.css";
import AboutMeadows from "../components/meadows/AboutMeadows";
import AboutMeadows1 from "../components/meadows/AboutMeadows1";
import Clubhouse from "../components/meadows/ClubHouseMeadows";
import GalleryMeadows from "../components/meadows/GalleryMeadows";
import MeadowsSpecificationAccordion from "../components/meadows/MeadowsSpecificationAccordion";
import ContactMeadows from "../components/meadows/ContactMeadows";
import ApprovedBanks from "../components/ApprovedBanks";
import MeadowsMasterplan from "../components/meadows/MeadowsMasterplan";
import LocationMeadows from "../components/meadows/LocationMeadows";
import FloorPlansMeadows from "../components/meadows/FloorPlansMeadows";
import VideoTourMeadows from "../components/meadows/VideoTourMeadows";

// import HeaderMeadows from "../components/meadows/HeaderMeadows";

import ConstructionProgressMeadows from "../components/meadows/ConstructionProgressMeadows";

const menuLinks = [
  { label: "ABOUT MEADOWS", target: "about-serene" },
  { label: "AMENITIES", target: "woods-clubhouse" },
  { label: "MASTERPLAN", target: "woods-masterplay" },
  { label: "FLOORPLANS", target: "meadows-floor-plans" },
  { label: "VIDEO TOUR", target: "meadows-video-tour" },
  { label: "LOCATION", target: "woods-location" },
  { label: "SPECIFICATIONS", target: "serene-specifications" },
  { label: "CONTACT", target: "serene-contact" },
];


function MeadowsSite() {
  return (
    <section id="home-meadows">
      <HeaderSerene logo={MeadowsLogo} menuLinks={menuLinks} />
      {/* <HeaderMeadows /> */}
      <HeroMeadows />
      <AboutMeadows />
      <AboutMeadows1 />
      <Clubhouse />
      <MeadowsMasterplan />
      <FloorPlansMeadows />
      <VideoTourMeadows />
      <LocationMeadows />
      {/* <GalleryMeadows /> */}
      {/* <ConstructionProgressMeadows /> */}
      <MeadowsSpecificationAccordion />
      <ApprovedBanks />
      <ContactMeadows />
    </section>
  );
}

export default MeadowsSite;
